if (!customElements.get('picker-popup')) {
  class PickerPopup extends HTMLElement {
    constructor() {
      super();

      if (window.innerWidth < 1000) {
        this.enableClickBehaviorForMobile();
      }
    }

    enableClickBehaviorForMobile() {
      this.button = this.querySelector('.picker-popup__button');
      this.content = this.querySelector('.picker-popup__content');
      this.close = this.querySelector('.picker-popup__content-close');

      // Store the original parent and next sibling to restore position
      this.originalParent = this.content.parentElement;
      this.originalNextSibling = this.content.nextSibling;


      // Event listener to open the content
      this.button.addEventListener('click', () => {
        this.openContent();
      });

      // Event listener to close the content
      this.close.addEventListener('click', () => {
        this.closeContent();
      });

      // Event listener to close the content on click outside the content
      this.content.addEventListener('click', (event) => {
        if (event.target === this.content) {
          this.closeContent();
        }
      });
    }

    openContent() {
      this.content.setAttribute('data-active', ''); // Set data-active on content
      document.body.style.overflow = 'hidden'; // Disable scrolling
      document.body.appendChild(this.content); // Move content to the end of the body
    }

    closeContent() {
      this.content.removeAttribute('data-active'); // Remove data-active from content
      document.body.style.overflow = ''; // Restore scrolling

      // Restore the content to its original position
      if (this.originalNextSibling) {
        this.originalParent.insertBefore(this.content, this.originalNextSibling);
      } else {
        this.originalParent.appendChild(this.content);
      }
    }
  }

  customElements.define('picker-popup', PickerPopup);
}
